import { render } from "./WYSIWYGField.vue?vue&type=template&id=24720ce3"
import script from "./WYSIWYGField.vue?vue&type=script&lang=js"
export * from "./WYSIWYGField.vue?vue&type=script&lang=js"

import "./WYSIWYGField.vue?vue&type=style&index=0&id=24720ce3&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__